// extracted by mini-css-extract-plugin
module.exports = {"RuleSettings":"RuleSettings_RuleSettings__hXlxq","ruleSettingsTable":"RuleSettings_ruleSettingsTable__17X12"};